(function () {
    if(!App.prod) {return;}
    function errorSend(error, data) {
        let body = {
            error: {
                type: '',
                url: window.location.toString(),
                error: error.toString(),
                stack: error.stack.toString(),
                ...data
            }
        };

        fetchPost('/error', body).then(response => {
            if(!App.prod) {
                console.log(error)
            }
        });
    }

    window.onerror = function (msg, url, lineNo, columnNo, error) {
        if (msg.toLowerCase().includes('script error')) {
            return console.log(msg);
        }
        errorSend(error, {
            type: 'Javascript Error',
            errorFile: url,
            columnNo,
        });
    };

    if(Vue) {
        Vue.config.errorHandler = function (err, vm, info) {
            errorSend(err, {
                type: 'Vue Error',
                component_name: vm.$options.name,
                info: info,
            });
        };
    }
})();
